module.exports = __webpack_public_path__ + "static/media/practice_test_mobile.5d969a23.webp";